import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    addModalVisible: false,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);


export default viewModel;
  

export {
    update,
    reset,
};
